<label
  class="checkbox-item">
  <input
    (change)="checkChange()"
    [(ngModel)]="state"
    type="checkbox"
    class="checkbox-item__input">
  <span class="checkbox-item__icon"></span>
</label>
